// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Chip button in posnavbar ── */
.weather-widget-chip {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  border-radius: 20px;
  border: none;
  background: #0f172a;
  color: #ffffff;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
  max-width: 200px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
}

.weather-widget-chip:hover {
  background: #1e293b;
}

.weather-widget-icon-container {
  background-color: rgba(255, 255, 255, 0.1);
  padding: 6px;
  border-radius: 20px;
  color: #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.weather-widget-chip-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}

.weather-widget-chip-text-top {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.weather-widget-chip-temp {
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  flex-shrink: 0;
  white-space: nowrap;
}

.weather-widget-chip-condition {
  color: #94a3b8;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.weather-widget-chip-location {
  color: #64748b;
  font-size: 10px;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark .weather-widget-chip { background: #0f172a; }
.dark .weather-widget-chip-temp { color: #ffffff; }
.dark .weather-widget-chip-condition { color: #94a3b8; }
.dark .weather-widget-chip-location { color: #64748b; }

/* ── Modal backdrop — anchored bottom-right ── */
.weather-widget-modal-root {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0 20px 76px 0;
  pointer-events: none;
}

.weather-widget-modal-root > * {
  pointer-events: auto;
}

/* ── Floating card — two-tone split ── */
.weather-widget-modal {
  width: 300px;
  border-radius: 20px;
  overflow: hidden;
  color: #ffffff;
  box-shadow: 0 20px 48px rgba(10, 30, 100, 0.45), 0 2px 10px rgba(0, 0, 0, 0.25);
  outline: none;
  background: #0d1b3e;
}

/* ── TOP: blue gradient header ── */
.weather-widget-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 18px 18px 18px 18px;
  background: linear-gradient(135deg, #62b0f8 0%, #3b82f6 50%, #2455d4 100%);
  position: relative;
  overflow: hidden;
}

.weather-widget-top-left {
  display: flex;
  flex-direction: column;
  gap: 3px;
  z-index: 1;
}

.weather-widget-main-temp {
  font-size: 52px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -2px;
  color: #fff;
}

.weather-widget-condition-text {
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.weather-widget-day-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  padding-top: 6px;
  z-index: 1;
}

.weather-widget-today {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
}

.weather-widget-date {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
  white-space: nowrap;
}

/* decorative large circle in header */
.weather-widget-bg-icon {
  position: absolute;
  bottom: -20px;
  right: -12px;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  pointer-events: none;
  z-index: 0;
}

/* ── BOTTOM: dark section containing stats + forecast ── */
.weather-widget-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 14px 12px 12px;
  background: #0d1b3e;
}

.weather-widget-metric-card {
  background: #162240;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  text-align: center;
  padding: 10px 4px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.weather-widget-metric-card span {
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  white-space: nowrap;
}

.weather-widget-metric-card small {
  font-size: 10px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1;
}

/* ── Forecast rows ── */
.weather-widget-forecast-list {
  background: #0d1b3e;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding: 4px 0 2px;
}

.weather-widget-forecast-row {
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  gap: 10px;
  padding: 9px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.weather-widget-forecast-day {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
}

.weather-widget-forecast-icon {
  color: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
}

.weather-widget-forecast-temp {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  min-width: 28px;
  text-align: right;
}

/* ── Footer ── */
.weather-widget-footer {
  background: #0d1b3e;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  padding: 8px 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.weather-widget-location-btn {
  border: 0;
  background: rgba(59, 130, 246, 0.3);
  color: rgba(255, 255, 255, 0.9);
  border-radius: 14px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px 10px;
  transition: background 0.15s;
  white-space: nowrap;
}

.weather-widget-location-btn:hover {
  background: rgba(59, 130, 246, 0.5);
}

.weather-widget-footer > span {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Misc ── */
.weather-widget-icon-img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.weather-widget-dash {
  opacity: 0.35;
  font-style: italic;
  letter-spacing: 1px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/WeatherWidget/WeatherWidget.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,0EAA0E;EAC1E,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6BAA6B,mBAAmB,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,uCAAuC,cAAc,EAAE;AACvD,sCAAsC,cAAc,EAAE;;AAEtD,iDAAiD;AACjD;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,+EAA+E;EAC/E,aAAa;EACb,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* ── Chip button in posnavbar ── */\n.weather-widget-chip {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  border: none;\n  background: #0f172a;\n  color: #ffffff;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n  max-width: 200px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);\n}\n\n.weather-widget-chip:hover {\n  background: #1e293b;\n}\n\n.weather-widget-icon-container {\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 6px;\n  border-radius: 20px;\n  color: #bfdbfe;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.weather-widget-chip-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  min-width: 0;\n}\n\n.weather-widget-chip-text-top {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.weather-widget-chip-temp {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.2;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.weather-widget-chip-condition {\n  color: #94a3b8;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.weather-widget-chip-location {\n  color: #64748b;\n  font-size: 10px;\n  font-weight: 400;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark .weather-widget-chip { background: #0f172a; }\n.dark .weather-widget-chip-temp { color: #ffffff; }\n.dark .weather-widget-chip-condition { color: #94a3b8; }\n.dark .weather-widget-chip-location { color: #64748b; }\n\n/* ── Modal backdrop — anchored bottom-right ── */\n.weather-widget-modal-root {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  padding: 0 20px 76px 0;\n  pointer-events: none;\n}\n\n.weather-widget-modal-root > * {\n  pointer-events: auto;\n}\n\n/* ── Floating card — two-tone split ── */\n.weather-widget-modal {\n  width: 300px;\n  border-radius: 20px;\n  overflow: hidden;\n  color: #ffffff;\n  box-shadow: 0 20px 48px rgba(10, 30, 100, 0.45), 0 2px 10px rgba(0, 0, 0, 0.25);\n  outline: none;\n  background: #0d1b3e;\n}\n\n/* ── TOP: blue gradient header ── */\n.weather-widget-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 18px 18px 18px 18px;\n  background: linear-gradient(135deg, #62b0f8 0%, #3b82f6 50%, #2455d4 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.weather-widget-top-left {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  z-index: 1;\n}\n\n.weather-widget-main-temp {\n  font-size: 52px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -2px;\n  color: #fff;\n}\n\n.weather-widget-condition-text {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.weather-widget-day-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n  padding-top: 6px;\n  z-index: 1;\n}\n\n.weather-widget-today {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n}\n\n.weather-widget-date {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.95);\n  white-space: nowrap;\n}\n\n/* decorative large circle in header */\n.weather-widget-bg-icon {\n  position: absolute;\n  bottom: -20px;\n  right: -12px;\n  width: 90px;\n  height: 90px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* ── BOTTOM: dark section containing stats + forecast ── */\n.weather-widget-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  padding: 14px 12px 12px;\n  background: #0d1b3e;\n}\n\n.weather-widget-metric-card {\n  background: #162240;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  text-align: center;\n  padding: 10px 4px 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.weather-widget-metric-card span {\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.weather-widget-metric-card small {\n  font-size: 10px;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.45);\n  line-height: 1;\n}\n\n/* ── Forecast rows ── */\n.weather-widget-forecast-list {\n  background: #0d1b3e;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n  padding: 4px 0 2px;\n}\n\n.weather-widget-forecast-row {\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.weather-widget-forecast-day {\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.weather-widget-forecast-icon {\n  color: rgba(255, 255, 255, 0.75);\n  display: flex;\n  align-items: center;\n}\n\n.weather-widget-forecast-temp {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  min-width: 28px;\n  text-align: right;\n}\n\n/* ── Footer ── */\n.weather-widget-footer {\n  background: #0d1b3e;\n  border-top: 1px solid rgba(255, 255, 255, 0.07);\n  padding: 8px 12px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.weather-widget-location-btn {\n  border: 0;\n  background: rgba(59, 130, 246, 0.3);\n  color: rgba(255, 255, 255, 0.9);\n  border-radius: 14px;\n  font-size: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 5px 10px;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n\n.weather-widget-location-btn:hover {\n  background: rgba(59, 130, 246, 0.5);\n}\n\n.weather-widget-footer > span {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.4);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Misc ── */\n.weather-widget-icon-img {\n  width: 22px;\n  height: 22px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.weather-widget-dash {\n  opacity: 0.35;\n  font-style: italic;\n  letter-spacing: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
